<template>
    <div class="swan-web-app">
        <div class="swan-chat-view" >
            <div class="items-center">
              <el-image style="width: 40px; height: 40px" :src="botInfo?.icon_url" fit="fill" />
              <div class="flex-col">
                  <strong>{{ botInfo?.name }}</strong>
                  <div>{{ botInfo?.description}}</div>
              </div>
            </div>
            <el-popover  placement="bottom" :width="200" trigger="hover" >
              <template #reference>
                <el-avatar   :size="30" :src="currentUser?.picUrl" style="cursor: pointer;" ></el-avatar>
              </template>
              <div class="user-float" >
                <div class="user-name">
                  <span style="">{{currentUser?.userName}}</span>
                </div>
                <ul>
                  <li class="css-1e76yen" @click="pushSearch(`/people`,`people`)">
                    <i class="iconfont ec-icon-s-user"></i>
                    <span>我的主页</span>
                  </li>
                  <li class="css-1e76yen" @click="pushSearch('/user-center','usercenter')">
                    <i class="iconfont ec-icon-setting-fill"></i>
                    <span>个人中心</span>
                  </li>
                  <li class="css-1e76yen" @click="loginOut">
                    <i class="iconfont ec-icon-exit"></i>
                    <span>退出</span>
                  </li>
                </ul>
              </div>
            </el-popover>
        </div>
        <div class="chat-body">
            <div class="chat-body-container">
                <div class="welcome-container" >
                    <div class="chat-answer-container" v-if="botInfo?.onboarding_info?.prologue">
                        {{ botInfo?.onboarding_info?.prologue  }}
                    </div>
                    <div class="question-guide-items" v-if="(chatList?.length ||0)<=0">
                        <div v-for="(item,index) in botInfo?.onboarding_info?.suggested_questions" :key="index" class="question-guide-item" @click="sendChatFun(2,item)">
                           <i class="iconfont ec-icon-xinbiaotilan-left icon-color"></i> {{ item }}
                        </div>
                    </div>
                </div>
                <div v-for="(item,index) in chatList" :key="index">
                  <div class="question-container">
                    <div>
                      <el-image v-for='(img,img_index) in item.fileList' :key="'img_'+img_index" style="width: 100px; height: 100px" :src="img.file_url" fit="fill" />
                    </div>
                    <div class="question-content">
                      {{ item.question }}
                    </div>
                  </div>
                  <div>
                    <div class="chat-answer-container">
                      <div v-if="!item.answer?.content && !item.answer?.reasoning_content.length>0">思考中... </div>
                      <div style="margin-bottom: 10px;color: rgba(15,21,40,0.6);">
                        <p v-for="(reasoning_item,r_index) in item.answer?.reasoning_content" :key="'r_'+r_index" >{{reasoning_item}}</p>
                      </div>
                      <div v-html="item.answer.content">
                      </div>
                    </div>
                    <div class="question-guide-items">
                        <div v-for="(f_item,index) in item?.answer?.follow_content" :key="index" class="question-guide-item" @click="sendChatFun(2,f_item)">
                           <i class="iconfont ec-icon-xinbiaotilan-left icon-color"></i> {{ f_item }}
                        </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="chat-input-box">
              <el-button  circle @click="clearChatFun()">
                <span class="iconfont ec-icon-delete "></span>
              </el-button>
                
                <div class="chat-input-box-textarea-wrapper">
                  <div id="upload-container"></div>
                  <div class="chat-input-box-textarea-and-icons">
                      <el-input  v-model="content"   placeholder="可以问我关于经济方面的问题..."  
                        type="textarea" autosize 
                        @keydown.enter.prevent="handleSend" 
                        @keydown.ctrl.enter="handleNewline"
                          style="margin-right: 10px;"  />
                      <el-space :size="15" spacer="|" >
                        <!-- <el-upload ref="uploadRef" class="custom-uploader"
                          action="/"
                          :http-request="fileUploadFun"
                          list-type="picture" 
                          multiple
                        >
                          <span class="iconfont ec-icon-image chat-input-box-icon"></span>
                          <template #file="{ file }">
                            <teleport to="#upload-container">
                              <div>
                                <img style="width: 60px;height: 60px;margin:5px" :src="file.url" alt="" />
                              </div>
                            </teleport>
                          </template>
                        </el-upload> -->
                          
                          <el-button type="text" link :disabled="content.length===0" @click="sendChatFun(1,'')">
                            <span class="iconfont ec-icon-send chat-input-box-icon"></span>
                          </el-button>
                      </el-space>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <el-dialog
        v-model="$store.state.loginVisable"
        title=""
        :width='420'
        custom-class="login-dialog"
        destroy-on-close 
        :close-on-click-modal='false'
        @close='loginCloseFun'>
        <login></login>
      </el-dialog>
</template>
<script>
import { CozeAPI,COZE_CN_BASE_URL, ChatEventType,RoleType } from '@coze/api';
import { ElMessage } from 'element-plus';
import { onMounted, ref,computed, inject } from 'vue';
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';
import {getJwtToken,getUserRightFun} from '@/http/basicsApi'
import Login from '@/components/Login'
import { useRouter,useRoute } from 'vue-router';
export default {
  components:{
    Login
  },
  setup() {
    const router=useRouter();//路由
    const route=useRoute();//当前路由
    let aiSearch=route.query['_chatQuery']||''//搜索内容
    console.log(aiSearch)
    //用户信息
    let currentUser=computed(()=>JSON.parse( localStorage.getItem('currentUser')));//当前用户信息
    let reload=inject('reload');

    const baseURL = COZE_CN_BASE_URL;
    const botId='7473028028160016399'
    let client = null;

    const md = new MarkdownIt({
      html: true,
      linkify: true
    });
    let botInfo=ref({})//智能体的配置信息
    let conversationInfo=ref({})//会话信息
    let content=ref('')//文本框用户输入的问题
    let chatList=ref([])//对话列表
    let uploadRef=ref()//上传组件
    let fileList=[]//上传文件的url列表
    onMounted(async ()=>{
      //初始化
      await createCozeApi()
      if(aiSearch){
        sendChatFun(2,aiSearch)
      }
    })
    /**
     * 输入框回车发送消息
     * @param e 
     */
    const handleSend = (e) => {
      // 纯Enter发送（排除所有修饰键）
      if (!e.ctrlKey && !e.shiftKey && !e.altKey && !e.metaKey) {
        e.preventDefault();// 防止默认换行行为
        if (content.value.trim()) {
          sendChatFun(1, '');
        }
      }
    }
    /**
     * 输入框ctrl+enter换行
     */
    const handleNewline = () => {
      content.value += '\n'; // 手动添加换行符
    };
    /**
     * 创建cozeAPi的对象
     */
    const createCozeApi=async()=>{
      let res= await getJwtToken()
      console.log('获取token',res)
      if(res.code==20000){
        //创建扣子对象
        client = new CozeAPI({
          baseURL,
          token:res.data,
          //allowPersonalAccessTokenInBrowser: true, // Allow the browers to use PAT
        });
        //获取智能体的配置信息
        botInfo.value = await client.bots.retrieve({
          bot_id: botId,
        });
      }
    }
    /**
     * 创建会话
    */
    const createConversation=async(title)=>{
      const conversation = await client.conversations.create({
        bot_id:botId,
        meta_data: {
        title: title//作为会话的标题
      },
      //   messages: [
      //     {
      //         role: RoleType.User,
      //         content_type: 'text',
      //         content: "你好，很高兴认识您",
      //         type: "question"
      //     }
      //   ]
      });
        console.log(conversation)
        conversationInfo.value= conversation;
        const messages = await client.conversations.messages.list(conversation.id);
        console.log('client.conversations.messages.list', messages);
      }

    /**
     * 创建对话
     */

    const sendChatFun=async(type,con)=>{
      let msg_content=type===1? content.value:con
      //判断是否创建会话，如何没有则创建，将会话的第一个消息作为会话的标题
      if(!conversationInfo.value.id){
        await createConversation(msg_content)
      }
      //创建对话
      let additional_messages_content=''
      let content_type='text'
      //如何有附加的文件、图片
      if(fileList.length>0){
        //fileList=[{"type": "file","file_url": ""}]
        additional_messages_content=JSON.stringify([...fileList,{type: "text",text: msg_content}])
        content_type='object_string'//多模态
      }
      else{
        additional_messages_content=msg_content
      }
      //对话参数
      let params={
        conversation_id: conversationInfo.value.id,
        bot_id: botId,
        user_id:currentUser.value?.userId.toString() || 'admin',
        auto_save_history: true,//是否保存本次对话记录
        stream:true,//是否启用流式返回。
        additional_messages: [
          {
            role: RoleType.User,
            content_type:content_type,
            content: additional_messages_content,
            type: "question"
          },
        ],
      }
      console.log('对话参数',params)
      const v =  client.chat.stream(params);
      const timestamp = Date.now();
      chatList.value.push({id:timestamp, question:msg_content,fileList:fileList,answer:{content:'',reasoning_content:[],follow_content:[]}})
      let index=chatList.value.length-1;//最新的对话
      content.value=''//输入框清空
      //文件重置
      fileList=[]//对本次的文件清空
      //uploadRef.value.clearFiles()//清空上传组件的文件列表
      //将上一次对话的问题建议重置
      if(index>0){
        chatList.value[index-1].answer.follow_content=[]
      }
      let answer_content=''
      //对话返回对象
      for await (const part of v) {
        if (part.event === ChatEventType.CONVERSATION_CHAT_CREATED) {
          console.log('[START]');
          console.log(part.data);
        } else if (part.event === ChatEventType.CONVERSATION_MESSAGE_DELTA) {
          console.log(part.data);
          if(part.data.reasoning_content){
            //添加到消息列表中最后一个中的reasoning_content
            let reasoning_index=chatList.value[index].answer.reasoning_content.length-1
            let ary= part.data.reasoning_content.split('\n')
            if(ary.length>1){
              chatList.value[index].answer.reasoning_content[reasoning_index]+=ary[0]
              chatList.value[index].answer.reasoning_content.push(ary[1])
            }
            else{
              chatList.value[index].answer.reasoning_content[reasoning_index]+=ary[0]
            }
            //滚动到页面底部
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: 'smooth' // 平滑滚动
            });
          }
          if(part.data.content){
            //添加到消息列表中最后一个中content
            answer_content+=part.data.content
            const rawHtml = md.render(answer_content);
            chatList.value[index].answer.content = DOMPurify.sanitize(rawHtml)// XSS 防护
            //滚动到页面底部
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: 'smooth' // 平滑滚动
            });
          }
        } else if (part.event === ChatEventType.CONVERSATION_MESSAGE_COMPLETED) {
          const { role, type, content } = part.data;
          if (role === 'assistant' && type === 'answer') {
            // process.stdout.write('\n');
            console.log('消息完成',part.data.content);
          }
          else if(role === 'assistant' && type === 'follow_up') {
            //在智能体上配置打开了用户问题建议开关，则会返回推荐问题相关的回复内容。
            chatList.value[index].answer.follow_content.push(part.data.content)
            //滚动到页面底部
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: 'smooth' // 平滑滚动
            });
          }
          else {
            console.log('[%s]:[%s]:%s', role, type, content);
          }
        } else if (part.event === ChatEventType.CONVERSATION_CHAT_COMPLETED) {
          console.log(part.data);
        } else if (part.event === ChatEventType.DONE) {
          console.log(part.data);
        } else if (part.event === ChatEventType.CONVERSATION_CHAT_FAILED) {
          console.log(part.data);
          chatList.value[index].answer.content=part.data.last_error.msg
        }
      }

      console.log('=== End of Streaming Chat ===');
      const messages = await client.conversations.messages.list(conversationInfo.value.id);
      console.log('client.conversations.messages.list', messages);
    }
    /**
     * 上传文件到服务器
     * @param ops 
     */
    const fileUploadFun=async(ops)=> {
      console.log('文件上传', ops)
      const _file = ops.file
      //console.log(_file);
      if (_file.type !== 'image/jpeg' && _file.type!=='image/png') {
          ElMessage.error('请上传jpg、png格式的图片!')
          return false
      } else if (_file.size / 1024 / 1024/512 > 1) {
          ElMessage.error('图片的大小不大于1MB!')
          return false
      }
      //调用接口上传到自己的服务器
      fileList=[{"type": "image","file_url": "https://data.chinaecono.com/report/botFile/123.png"},{"type": "image","file_url": "https://data.chinaecono.com/report/botFile/456.png"}]
      /*
      //上传到coze服务器返回文件ID
      // const fileObj = await client.files.upload({file:_file});
      // console.log(fileObj)
      */
    }
    /***
     * 清除会话，
     */
    const clearChatFun=async()=>{
      chatList.value=[]//重置页面上的对话列表
      conversationInfo.value={}//重置会话
      /*
      const section = await client.conversations.clear(conversationInfo.value.id)
      console.log('section',section)
      const messages = await client.conversations.messages.list(conversationInfo.value.id);
      console.log('client.conversations.messages.list', messages);
      */
    }
    //关闭登录对话框跳转到首页
    const loginCloseFun=()=>{
      router.push('/');
    }
    //搜索跳转
    const pushSearch= async (path,name)=>{
      console.log('路由判断页面是否可以访问',name);
      if(await getUserRightFun(name,0)){
        let href_='';
          const { href } = router.resolve({
            path: path,
          });
          href_=href;
        console.log(href_);
        window.open(href_, "_blank");
      }
          
    }
    //退出
    const loginOut=()=>{
      //loginOut('xxx').then(response=>{// eslint-disable-line no-unused-vars
          localStorage.removeItem("accesstoken");
          localStorage.removeItem("currentUser");
          localStorage.removeItem("refreshToken"); 
          if(route.path=='/' || route.path=='/index'){
              reload();
          }
          else{
              router.push('/')
          }
    }
    // 显式导出
    return {
      currentUser,
      botInfo,
      conversationInfo,
      content,
      chatList,
      handleSend,
      handleNewline,
      sendChatFun,
      clearChatFun,
      fileUploadFun,
      uploadRef,
      loginCloseFun,
      pushSearch,
      loginOut
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables.scss';
.swan-web-app {
    height: 100vh;
    position: relative;
    width: 100%;
    margin: 0 auto;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    flex-direction: column;
    background: linear-gradient(180deg, rgba(102,133,255,.2) 50%, rgba(255, 255, 255, 0) 100%);
}
.swan-chat-view {
    color: rgba(30, 31, 36, 0.88);
    font-size: 14px;
    box-sizing: border-box;
    background-color: #fff;
    border-color: rgba(237, 237, 240, 1) !important;
    border-bottom-width: 1px !important;
    display: flex;
    align-items: center ;
    justify-content: space-between;
    flex-direction: row;
    padding:10px 22px ;
    z-index: 99;
}
.items-center {
  display: flex;
  align-items: center ;
  flex-direction: row;
}

.flex-col {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-left: 10px;
}
.chat-body{
    flex: 1;
    max-width: 740px;
    width: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
.chat-body-container {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    flex-direction: column;
    display: flex;
    flex: 1 1;
}
//开场白样式
.welcome-container {
    padding-bottom: 8px;
    padding-top: 18px;
    position: relative;
    width: 100%;
    transition: height .16s ease-in-out;
    box-sizing: border-box;
}
.question-guide-items {
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    flex-direction: column;
    gap: 8px;
}
.question-guide-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 7.5px 12px;
  background-color: #fff;
  border-radius: 12px;
  gap: 6px;
  max-width: -moz-fit-content;
  max-width: fit-content;
  cursor: pointer;
  animation: item-position .32s, opacity .24s;
  animation-fill-mode: forwards;
}
@keyframes item-position {
  0% {
    transform: translatey(10px); 
  }
  100% {
      transform: translatey(0);
  }
}
@keyframes opacity {
  0% {
    opacity: 0;
}
100% {
    opacity: 1;
}
}
.question-container {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column;
    overflow: hidden;
    word-wrap: break-word;
    margin-bottom: 10px;
    .question-content {
      display: inline-block;
      box-sizing: border-box;
      padding: 9px 13px;
      background-color: rgba($themeColor, .1);
      position: relative;
      font-size: 16px;
      line-height: 28px;
      letter-spacing: .6px;
      text-align: left;
      border-radius: 18px 3px 18px 18px;
      word-break: break-all;
  }
}

.chat-answer-container {
  background-color: #fff;
  margin-bottom: 10px;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  line-height: 28px;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  transition: height .16s ease-in-out;
  margin-bottom: 10px;
  text-align: justify;
  box-sizing: border-box;
  border-radius: 3px 15px 15px 15px;
}

.chat-input-box {
    padding: 8px 32px 24px;
    background-color: unset;
    position: relative;
    z-index: 11;
    box-sizing: border-box;
    padding-top: 9px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    -webkit-user-select: none;
    user-select: none;
    color: #333;
    gap: 12px;
}
.chat-input-box-textarea-wrapper
 {
    padding-top: 12px;
    padding-bottom: 12px;
    border: 1.5px solid $themeColor;
    height: auto;
    background-color: #fff;
    position: relative;
    flex: 1 1;
    -webkit-tap-highlight-color: transparent;
    border-radius: 24px;
    box-sizing: border-box;
    overflow-x: hidden;
}
.chat-input-box-textarea-and-icons {
    padding: 0 12px;
    flex: 1 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    :deep(.el-textarea__inner){
      border:none;
      max-height: 150px;
    }
}
.chat-input-box-icon {
    width: 28px;
    height: 28px;
    font-size: 20px;
    cursor: pointer;
}
#upload-container{
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 0 10px;
}
.icon-color{
  color:$themeColor;
}
.chat-answer-container :deep( table) {
  width: 100%;
  border-collapse: collapse;
  thead tr:first-of-type th {
    border-top: 1px solid #edeef0;
  }
  thead tr th:first-of-type {
    border-left: 1px solid #edeef0;
  }
  thead th {
    background: #f5f6f9;
    border-bottom: 1px solid #edeef0;
    border-right: 1px solid #edeef0;
    border-top: 0;
    box-sizing: border-box;
    max-width: 212px;
    padding: 10.5px 16px 7.5px;
    white-space: wrap;
  }
  tbody tr td:first-of-type {
    border-left: 1px solid #edeef0;
  }
  tbody td {
    background: #fff;
    border-bottom: 1px solid #edeef0;
    border-right: 1px solid #edeef0;
    box-sizing: border-box;
    max-width: 212px;
    padding: 10.5px 16px;
    position: relative;
    white-space: wrap;
  }
}
</style>